<div class="flex flex-col items-center justify-center min-h-[60vh] text-center">

  <h1>You do not have access to this account</h1>
  @if (accountId.AccountNumber) {
    <h2>Source System: {{ accountId.SourceSystemId }}</h2>
    <h2>Health System: {{ accountId.HealthSystemId }}</h2>
    <h2>Account Number: {{ accountId.AccountNumber }}</h2>
  }

  <h1>
    Please request access
    <a
      href="https://forms.cloud.microsoft/r/Rz59Z3jazg"
      class="text-r1-blue-800 underline hover:text-r1-blue-900 focus:outline-none focus:ring-2 focus:ring-r1-blue-800"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Request access form"
    >
      here
    </a>.
  </h1>
</div>